import { Link } from 'react-router-dom';
import { useQuests, type QuestChainDto, type QuestStepDto } from '../api/quests';
import { npcPortraitPath } from '../compositor/assetPaths';

/** The first active chain's active step (chains arrive in the server's own order), or null. */
export function nextStep(chains: QuestChainDto[]): { chain: QuestChainDto; step: QuestStepDto } | null {
  for (const chain of chains) {
    if (chain.state !== 'active') continue;
    const step = chain.steps.find((s) => s.state === 'active');
    if (step) return { chain, step };
  }
  return null;
}

/** docs/SCREENS.md Habitat `next-step` (player review 2026-09-27, Demo A). Absent — not an empty
 *  shell — while loading, on error, or with nothing active. */
export function NextStepCard() {
  const quests = useQuests();
  const next = quests.data ? nextStep(quests.data.chains) : null;
  if (!next) return null;
  const { chain, step } = next;
  return (
    <Link to={`/world/lands/${chain.landCode}`} className="next-step-card">
      <img className="next-step-face" src={npcPortraitPath(chain.npcCode)} alt="" />
      <span className="next-step-text">
        <span className="next-step-eyebrow">{`Next · ${chain.title} ${step.stepNo} of ${chain.steps.length}`}</span>
        <span className="next-step-line">{step.narrative ?? step.name}</span>
      </span>
      <span className="next-step-go" aria-hidden="true">›</span>
    </Link>
  );
}
